import { createAction } from 'redux-actions';
import { SubscriptionsTierContentType } from '../../types/subscriptionsSection';

export const setSelectedTierId = createAction(
  'SUBSCRIPTIONS_SECTION/SET_SELECTED_TIERID',
  (payload: number) => payload
);

export const setSelectedTierContentType = createAction(
  'SUBSCRIPTIONS_SECTION/SET_SUBSCRIPTIONS_SECTION_TYPE',
  (payload: SubscriptionsTierContentType) => payload
);
